"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toastTypes = exports.toastSizes = exports.toastNovoDark = exports.toastNovo = exports.toast = void 0;
const polished_1 = require("polished");
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const timing_const_1 = __importDefault(require("../choices/timing.const"));
const zIndex_const_1 = __importDefault(require("../choices/zIndex.const"));
const textLink_const_1 = require("./textLink.const");
const { novo, novoDark } = oxygen_theme_1.default;
const verticalPaddingOffset = 4;
const toast = {
    // Sizes
    toastSmall: '368px',
    toastMedium: '480px',
    toastLarge: '800px',
    // Animation
    animationEnterDuration: parseInt(timing_const_1.default.medium, 10),
    animationEnterTimingFunction: 'easeIn',
    animationExitDuration: parseInt(timing_const_1.default.fast, 10),
    animationExitTimingFunction: 'easeOut',
    animationFlipDuration: parseInt(timing_const_1.default.fast, 10),
    // Types
    backgroundColor: color_const_1.default.steel700,
    backgroundColorError: color_const_1.default.goldenBell,
    color: color_const_1.default.white,
    colorError: color_const_1.default.pickledBluewood800,
    colorTitle: undefined,
    colorDescription: undefined,
    colorAction: undefined,
    textLinkAsAction: {
        ...textLink_const_1.textLink,
        textLinkPadding: '0',
    },
    closeIconColor: undefined,
    markingColorError: undefined,
    markingColorInfo: undefined,
    markingColorSuccess: undefined,
    markingColorWarning: undefined,
    boxShadow: `0 1px 5px 0 ${(0, polished_1.rgba)(color_const_1.default.pickledBluewood800, 0.2)}`,
    // Typography
    fontFamily: font_const_1.default.family,
    fontSize: font_const_1.default.sizeSm,
    fontWeight: font_const_1.default.weightAttention,
    lineHeight: font_const_1.default.lineHeightSm,
    fontFamilyTitle: undefined,
    fontSizeTitle: undefined,
    fontWeightTitle: undefined,
    letterSpacingTitle: undefined,
    lineHeightTitle: undefined,
    fontFamilyDescription: undefined,
    fontSizeDescription: undefined,
    fontWeightDescription: undefined,
    letterSpacingDescription: undefined,
    lineHeightDescription: undefined,
    letterSpacing: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    textAlign: 'left',
    // Structure
    borderRadius: size_const_1.default.borderRadiusDefault,
    padding: `${parseInt(size_const_1.default.default2x, 10) - verticalPaddingOffset}px ${size_const_1.default.default2x}`,
    maxHeight: '120px',
    maxWidth: '100%',
    stackMargin: '16px',
    structureMargin: novo.spacing03,
    zIndex: zIndex_const_1.default.z5000,
    iconSize: 20,
    // Control
    marginControl: '12px',
    isClassic: true,
};
exports.toast = toast;
const toastNovo = {
    isClassic: false,
    // Sizes
    toastSmall: '320px',
    toastMedium: '480px',
    toastLarge: '800px',
    // Animation
    animationEnterDuration: parseInt('300ms', 10),
    animationEnterTimingFunction: 'easeIn',
    animationExitDuration: parseInt('150ms', 10),
    animationExitTimingFunction: 'easeOut',
    animationFlipDuration: parseInt('150ms', 10),
    // Types
    markingColorError: novo.error01,
    markingColorInfo: novo.info01,
    markingColorSuccess: novo.success01,
    markingColorWarning: novo.warning01,
    color: undefined,
    colorError: undefined,
    colorTitle: novo.textColor04,
    colorDescription: novo.textColor04,
    colorAction: novo.action06,
    textLinkAsAction: {
        ...textLink_const_1.textLinkNovoDark,
        ...novo.bodyBold01,
        textLinkPadding: '0',
    },
    closeIconColor: novo.icon05,
    backgroundColor: novo.ui07,
    backgroundColorError: undefined,
    boxShadow: `0px 6px 20px ${(0, polished_1.rgba)(novo.shadow01, 0.25)}`,
    // Typography
    fontFamily: undefined,
    fontSize: undefined,
    fontWeight: undefined,
    lineHeight: undefined,
    letterSpacing: undefined,
    fontFamilyTitle: novo.bodyBold01.fontFamily,
    fontSizeTitle: novo.bodyBold01.fontSize,
    fontWeightTitle: novo.bodyBold01.fontWeight,
    letterSpacingTitle: novo.bodyBold01.letterSpacing,
    lineHeightTitle: novo.bodyBold01.lineHeight,
    fontFamilyDescription: novo.body01.fontFamily,
    fontSizeDescription: novo.body01.fontSize,
    fontWeightDescription: novo.body01.fontWeight,
    letterSpacingDescription: novo.body01.letterSpacing,
    lineHeightDescription: novo.body01.lineHeight,
    fontStyle: 'normal',
    fontStretch: 'normal',
    textAlign: 'left',
    // Structure
    borderRadius: '6px',
    stackMargin: novo.spacing03,
    maxHeight: '160px',
    maxWidth: '100%',
    padding: `${novo.spacing03} ${novo.spacing05} ${novo.spacing03} 0`,
    zIndex: 5000,
    iconSize: 20,
    structureMargin: novo.spacing03,
    // Control
    marginControl: undefined,
};
exports.toastNovo = toastNovo;
const toastNovoDark = {
    ...toastNovo,
    // Types
    markingColorError: novoDark.error01,
    markingColorInfo: novoDark.info01,
    markingColorSuccess: novoDark.success01,
    markingColorWarning: novoDark.warning01,
    colorTitle: novoDark.textColor04,
    colorDescription: novoDark.textColor04,
    colorAction: novoDark.action06,
    closeIconColor: novoDark.icon05,
    textLinkAsAction: {
        ...textLink_const_1.textLinkNovo,
        ...novo.bodyBold01,
        textLinkPadding: '0',
    },
    backgroundColor: novoDark.ui07,
    boxShadow: `0px 6px 20px ${(0, polished_1.rgba)(novoDark.shadow01, 0.25)}`,
};
exports.toastNovoDark = toastNovoDark;
const toastSizes = {
    small: 'small',
    medium: 'medium',
    large: 'large',
};
exports.toastSizes = toastSizes;
const toastTypes = {
    success: 'success',
    error: 'error',
    warning: 'warning',
    info: 'info',
};
exports.toastTypes = toastTypes;
